import { Info, X } from 'lucide-react'
import { useState } from 'react'
import { publicConfig } from '@/config/publicConfig'

interface DemoEnvironmentBannerProps {
  className?: string
}

type DemoEnvironment = 'Development' | 'Staging'

function getDemoEnvironment(apiDomain: string | undefined): DemoEnvironment | null {
  const normalizedDomain = apiDomain?.toLowerCase() ?? ''

  if (normalizedDomain.includes('staging')) {
    return 'Staging'
  }

  if (normalizedDomain.includes('dev')) {
    return 'Development'
  }

  return null
}

const DemoEnvironmentBanner = ({ className = '' }: DemoEnvironmentBannerProps) => {
  const [isDismissed, setIsDismissed] = useState(false)
  const environment = getDemoEnvironment(publicConfig.api.domain)

  if (!environment || isDismissed) {
    return null
  }

  return (
    <div
      className={`flex min-h-10 w-full items-center justify-between gap-3 border-y border-l-4 border-y-primary/50 border-l-warning bg-panel px-3 py-2 text-[var(--color-text-2)] shadow-lg ${className}`}
      role="alert"
    >
      <div className="flex min-w-0 items-center gap-3">
        <Info className="h-5 w-5 shrink-0 text-warning" aria-hidden="true" />
        <span className="shrink-0 rounded border border-primary/50 bg-primary/20 px-2 py-1 text-xs font-bold uppercase text-primary">
          {environment}
        </span>
        <p className="text-sm">
          <span className="font-bold">DEMO ENVIRONMENT</span>
          {' — All balances, trades, P&L and funds are simulated, and have no real-world value.'}
        </p>
      </div>
      <button
        type="button"
        onClick={() => setIsDismissed(true)}
        className="flex h-8 w-8 shrink-0 items-center justify-center rounded border border-[var(--color-border-strong)] text-[var(--color-text-2)] transition-colors duration-200 hover:bg-[var(--color-layer-4)]"
        aria-label="Dismiss demo environment notice"
        title="Dismiss notice"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  )
}

export default DemoEnvironmentBanner
